<template>
  <v-col
    :cols="default_cols"
    :md="default_md"
    class="pa-0"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>{{ title }}</v-list-item-subtitle>
        <v-list-item-title>
          <router-link
            v-if="link && value"
            :to="link"
          >
            {{ value }}
          </router-link>
          <a
            v-else-if="href && value"
            :href="href"
            target="_blank"
          >
            {{ value }}
          </a>
          <div v-else-if="value && separator">
            <AppChips
              :value="value"
              :separator="separator"
            />
          </div>
          <span
            v-else
            style="white-space: pre-line;"
          >
            {{ (value) ? value : '-' }}
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider v-if="default_hidden_divider" />
  </v-col>
</template>

<script>
import AppChips from "./AppChips";

export default {
  name: "AppDetailLabel",
  components: {
    AppChips,
	},
	props: {
    title: {
      type: String,
      default: ""
    },
    cols: {
      type: Number,
      default: 12
    },
    md: {
      type: Number,
      default: 6
    },
    hiddenDivider: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    separator: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
  },
	data() {
		return {
			default_cols: this.cols || 12,
      default_md: this.md || 6,
      default_hidden_divider: (this.hiddenDivider) ? false : true
		};
	}
};
</script>

<style scoped>
</style>